import { Component, Output, EventEmitter, Input, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { LineAttachment } from 'src/app/pages/employee/services/employee.service';
import { PortalSettingsService } from 'src/app/core/services/portal-settings.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { HomeService } from 'src/app/pages/home/services/home.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-read-only-pdf-viewer',
  templateUrl: './read-only-pdf-viewer.component.html',
  styleUrls: ['./read-only-pdf-viewer.component.css']
})
export class ReadOnlyPdfViewerComponent implements OnInit, OnChanges {
  @Input() attachment: LineAttachment = null;
  @Output() alertCreated: EventEmitter<Alert> = new EventEmitter<Alert>();
  alert: Alert | null = null;
  pdfUrl: SafeResourceUrl | null = null;
  downloadURL: string | null = null;
  portalSettings: any;

  constructor(private utilityService: UtilityService, private homeService: HomeService, private sanitizer: DomSanitizer, private portalSettingsService: PortalSettingsService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.attachment) {
      if (this.attachment) {
        this.getPDFData(this.attachment);
      } else if (!changes.attachment.firstChange) {
        this.pdfUrl = null;
      }
    }
  }

  private async getPDFData(attachment: LineAttachment): Promise<void> {
    try {
      this.utilityService.openModal();

      if (!this.utilityService.fileExtensionIsValid(attachment.AttachmentFileName)) {
        this.alertCreated.emit({ type: "danger", msg: "Attachment has an invalid file extension: " + attachment.AttachmentFileName });
        return;
      }

      if (this.utilityService.fileIsNotViewable(attachment.AttachmentFileName)) {
        this.pdfUrl = null;
        this.downloadURL = "/Document/GetDBAttachment?attachmentID=" + attachment.FileAttachmentID;
        return;
      }

      this.downloadURL = null;
      const response: Blob | null = await this.homeService.getPdfFile(attachment.FileAttachmentID).toPromise();

      if (response) {
        const url: string = URL.createObjectURL(response);
        const viewerPrefix: string = "/dist/assets/pdfjs/web/viewer.html?file=";
        const viewerUrl: string = viewerPrefix + url;
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(viewerUrl);
      } else {
        this.alertCreated.emit({ type: "danger", msg: "Attachment not found" });
      }
    } catch (error) {
      this.alertCreated.emit({ type: "danger", msg: "Error loading attachment" });
    } finally {
      this.utilityService.closeModal();
    }
  }
}

export interface Alert {
  type: "danger" | "success";
  msg: string;
}